import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationPlanWorkFinanceAttributions(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTIONS,
		options
	)
}

function _getRegulationPlanWorkFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		options
	)
}

function _createRegulationPlanWorkFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].CREATE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		options
	)
}

function _putRegulationPlanWorkFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].PUT_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		options
	)
}

function _patchRegulationPlanWorkFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].PATCH_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		options
	)
}

function _deleteRegulationPlanWorkFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].DELETE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTIONS]: _getRegulationPlanWorkFinanceAttributions,

	[ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: _getRegulationPlanWorkFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].CREATE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: _createRegulationPlanWorkFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].PUT_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: _putRegulationPlanWorkFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].PATCH_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: _patchRegulationPlanWorkFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION].DELETE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: _deleteRegulationPlanWorkFinanceAttribution,
}
